import React from "react";
import { Box, Button, Dialog, IconButton } from "@material-ui/core";
import { useStyles } from './styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import CancelIcon from '@material-ui/icons/Cancel';
import { Link } from 'react-router-dom';
import ErrorIcon from '@material-ui/icons/Error';

export const FinancialHardshipAlert = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      fullScreen={fullScreen}
      PaperProps={{ classes: { root: classes.dialogStyle } }}
      onClose={props.handleClose}
      open={props.open}
    >
      <Box className={classes.root}>
        <IconButton className={classes.iconStyle} onClick={props.handleClose}>
          <CancelIcon />
        </IconButton>
        <Box className={classes.body}>
          <h1 className={classes.title}>Having Financial Difficulty?</h1>
          <p className={classes.subTitle}>Struggling with mortgage payments? Seek financial help by clicking below.</p>
          <Box className={classes.buttonBox}>
            <Button component={Link} to='/FinancialHardship' className={classes.btn} variant="contained" color='primary' >financial hardship</Button>
          </Box>
          <p className={classes.warningText}><ErrorIcon style={{ fill: '#EB4F4F', marginRight: '7px' }} /> Payment Options are Disabled </p>
          <p className={classes.subTitle}>You can <Link className={classes.linkStyle} onClick={props.handleClose} to='/HelpLanding?contactus'>contact us</Link> to discuss available payment options and verify the amount due.</p>
          <p className={classes.subTitle}>If you have any further payment or hardship  related questions, please visit our <Link className={classes.linkStyle} onClick={props.handleClose} to='/HelpDescription/FAQs'>FAQs </Link>page.</p>
        </Box>
      </Box>
    </Dialog>
  )
}
